import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group whitespace-nowrap">
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-lg font-heading">
              漫
            </span>
            <span className="text-foreground-950 font-heading font-bold text-xl hidden sm:block">
              073漫画网
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {/* Category dropdown */}
            <div className="relative group">
              <button className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors flex items-center gap-1 whitespace-nowrap">
                分类
                <i className="ri-arrow-down-s-line text-sm"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 bg-background-50 border border-background-200 rounded-xl shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 p-2 min-w-[200px] grid grid-cols-2 gap-1 z-50">
                {categories.slice(1).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* Right */}
          <div className="flex items-center gap-3">
            {/* Search */}
            <div className="hidden sm:flex items-center bg-background-100 border border-background-200 rounded-full px-4 py-2 gap-2">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="bg-transparent border-none outline-none text-sm text-foreground-800 placeholder-foreground-400 w-40"
              />
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
            >
              <i
                className={`text-xl text-foreground-700 ${
                  mobileOpen ? "ri-close-line" : "ri-menu-line"
                }`}
              ></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              首页
            </Link>
            <div className="px-4 py-2 text-xs font-medium text-foreground-400 uppercase">
              分类浏览
            </div>
            {categories.slice(1).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 rounded-lg text-sm text-foreground-600 hover:bg-background-100 transition-colors flex items-center gap-2"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200 my-2" />
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              关于我们
            </Link>
            <div className="px-4 pt-2">
              <div className="flex items-center bg-background-100 border border-background-200 rounded-full px-4 py-2 gap-2">
                <i className="ri-search-line text-foreground-400 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="bg-transparent border-none outline-none text-sm text-foreground-800 placeholder-foreground-400 w-full"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}